export const LOG_KEY = 'shopping-bag-provider';

const getTime = () => {
  const date = new Date();
  const LAST_TWO_DIGITS = -2;
  const LAST_THREE_DIGITS = -3;

  return `${date.getHours()}:${`0${date.getMinutes()}`.slice(
    LAST_TWO_DIGITS,
  )}:${`0${date.getSeconds()}`.slice(LAST_TWO_DIGITS)}.${`00${date.getMilliseconds()}`.slice(
    LAST_THREE_DIGITS,
  )}`;
};

export const isLoggerOn = () =>
  Boolean(window.localStorage) &&
  Boolean(JSON.parse(localStorage.getItem(`${LOG_KEY} debug`) ?? '0'));

export const log = <Args extends readonly unknown[]>(...args: Args) => {
  if (!isLoggerOn()) {
    return;
  }

  const time = getTime();
  // eslint-disable-next-line no-console -- simple logger
  console.log(`%c${time} %c${LOG_KEY}:`, 'color: #09c', 'color: #c90;', ...args);
};

export const logReceivedEvent = <T extends CustomEvent>(event: T) =>
  log(`Received ${event.type} event:\n\t`, event);
